import { OnboardingNewUiUxReduxActions } from "./onboardingNewUiUx.action";

const initialState = {
  stepper: {
    current_step: "resume_upload_page",
    step_sequence: [
      "resume_upload_page",
      "basic_profile_page",
      "education_page",
      "role_skills_page",
      "links_page",
      "publications_page",
      "profile_summary",
    ],
    step_details: {
      resume_upload_page: {
        step_name: "resume_upload_page",
        title: "Resume Upload",
        isVisited: false,
      },
      basic_profile_page: {
        step_name: "basic_profile_page",
        title: "Basic information",
        isVisited: false,
      },
      education_page: {
        step_name: "education_page",
        title: "Education",
        isVisited: false,
      },
      role_skills_page: {
        step_name: "role_skills_page",
        title: "Skills and languages",
        isVisited: false,
      },
      links_page: {
        step_name: "links_page",
        title: "Professional Profiles",
        isVisited: false,
      },
      publications_page: {
        step_name: "publications_page",
        title: "Published Work",
        isVisited: false,
      },
      profile_summary: {
        step_name: "profile_summary",
        title: "Profile summary",
        isVisited: false,
      },
    },
  },
  userInfo: {},
  countries: [],
  excludedCountries: [],
  languages: [],
  resume_upload_page: {
    hasErrors: {},
    values: {},
  },
  basic_profile_page: {
    hasErrors: {},
    values: {
      firstName: null,
      lastName: null,
      country_id: undefined,
      phoneNumber: null,
      phoneCountry: null,
      expected_salary: null,
      ref_checked_values: [],
      ref_other_value: null,
      salary_local_currency: null,
    },
  },
  education_page: {
    hasErrors: {},
    values: [
      {
        college: "",
        country_id: "",
        degree: "",
        level: "",
        start_year: "",
        start_month: "",
        end_year: "",
        end_month: "",
        is_current: false,
      },
    ],
  },
  role_skills_page: {
    hasErrors: {},
    values: {
      selected_role_skills: [],
      job_role_id: undefined,
      job_role_text: null,
      selected_skills_data: [],
      yearsOfExperience: null,
      developerLanguageProficiencies: [],
      languageIdsToBeDeleted: [],
    },
  },
  publications_page: {
    hasErrors: {},
    values: [],
  },
  links_page: {
    hasErrors: {},
    values: [],
  },
  profile_summary: {
    hasErrors: {},
  },
  fetchJobsRemaining: false,
  forecastedJobId: null,
  jobsLoading: false,
  formSubmitting: false,
  basicInfoDataFetched: false,
  socialProofInfo: {},
  usedLinkedInOrResume: false,
  isResumeUploadBannerClosed: false,
};

function OnboardingNewUiUxReducer(state = initialState, action) {
  const { type = "", payload = null } = { ...action };
  switch (type) {
    case OnboardingNewUiUxReduxActions.SET_CURRENT_STEP: {
      return {
        ...state,
        stepper: {
          ...state.stepper,
          current_step: payload, // Update only current_step
        },
      };
    }

    case OnboardingNewUiUxReduxActions.MARK_STEP_AS_VISITED: {
      return {
        ...state,
        stepper: {
          ...state.stepper,
          step_details: {
            ...state.stepper.step_details,
            [payload]: {
              ...state.stepper.step_details[payload],
              isVisited: true,
            },
          },
        },
      };
    }

    case OnboardingNewUiUxReduxActions.UPDATE_STATE_DATA: {
      return { ...state, ...payload };
    }
    case OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES: {
      const { page, values } = payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          values: Array.isArray(values)
            ? values
            : { ...state[page]["values"], ...values },
        },
      };
    }
    case OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA: {
      const { page, errors } = payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          hasErrors: errors,
        },
      };
    }

    case OnboardingNewUiUxReduxActions.SET_JOBS_LOADING: {
      return { ...state, jobsLoading: payload };
    }
    case OnboardingNewUiUxReduxActions.FETCH_JOBS_REMAINING: {
      return { ...state, fetchJobsRemaining: payload };
    }
    case OnboardingNewUiUxReduxActions.SET_FORECASTED_JOBS: {
      return { ...state, forecastedJobId: payload };
    }

    case OnboardingNewUiUxReduxActions.FORM_SUBMITTING: {
      return { ...state, formSubmitting: payload };
    }

    case OnboardingNewUiUxReduxActions.MARK_RESUME_UPLOAD_BANNER_AS_CLOSED: {
      return { ...state, isResumeUploadBannerClosed: true };
    }

    case OnboardingNewUiUxReduxActions.RESET_STORE: {
      return {
        ...initialState, stepper: {
          ...initialState.stepper,
          current_step: state.stepper.current_step
        }
      };
    }
    case OnboardingNewUiUxReduxActions.FETCHED_SOCIAL_PROOF_INFO: {
      return { ...state, socialProofInfo: payload }
    }
    case OnboardingNewUiUxReduxActions.USED_LINKEDIN_OR_RESUME: {
      return { ...state, usedLinkedInOrResume: true }
    }
    default:
      return state;
  }
}

export default OnboardingNewUiUxReducer;
